import config from 'config';

export function rewriteEmojiPath<T extends { emoji?: string }>(object: T): T {
  const { emoji } = object;
  if (!emoji) {
    return object;
  }
  const match = emoji.match(/\/([^/]+.png)$/i);
  const filename = match?.[1];
  if (!filename) {
    return object;
  }
  const newEmoji = `${config.emojiCdnPath}/${filename}`;

  return {
    ...object,
    emoji: newEmoji,
  };
}
